import type { Room } from 'matrix-js-sdk'
import type { IMessage } from '@/modules/chat-matrix-fast/types/IChat'
import type { OutboxPendingItem } from '@/modules/chat-matrix-fast/services/messageOutbox'
import { outboxItemToMessage } from '@/modules/chat-matrix-fast/services/messageOutbox'
import { findRoomEventForClientTxn } from '@/modules/chat-matrix-fast/services/matrixTextDelivery'

export function shouldDeferOutboxUiToFlush(options: {
  navigatorOnline: boolean
  syncAlive: boolean
}): boolean {
  return options.navigatorOnline && options.syncAlive
}

export function outboxItemsForUiHydrate(
  pending: OutboxPendingItem[],
  room: Room | null,
  author: { id: string; full_name?: string; avatar?: string },
): IMessage[] {
  return pending
    .filter(item => !findRoomEventForClientTxn(room, item.clientTxnId))
    .map(item => outboxItemToMessage(item, author))
}

export function removeFlushedOutboxBubble(
  messages: IMessage[],
  outboxRowId: string,
): boolean {
  const eventId = `~outbox:${outboxRowId}`
  const index = messages.findIndex(message => message.matrix_event_id === eventId)
  if (index === -1) {
    return false
  }
  messages.splice(index, 1)
  return true
}
